import { render, staticRenderFns } from "./SmallAmountOldAge.vue?vue&type=template&id=3768135e"
import script from "./SmallAmountOldAge.vue?vue&type=script&lang=js"
export * from "./SmallAmountOldAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports